// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { LatencyBand, ILatencyBand } from "./ClientEndpoints.LatencyBand.gen";

export interface IHealthBucket {
	hourUtc: string | undefined;

	sends: number;

	failures: number;

	slowSends: number;

	p95Ms: ILatencyBand | undefined;

	hasRawDetail: boolean;

	$type?: string | undefined;
}
export class HealthBucket {
	constructor(data?: IHealthBucket) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.hourUtc) { this.hourUtc = new Date(data.hourUtc); }
		if (data.p95Ms) { this.p95Ms = new LatencyBand(data.p95Ms); }
	}

	hourUtc: Date | undefined = new Date();

	sends: number = 0;

	failures: number = 0;

	slowSends: number = 0;

	p95Ms: LatencyBand | undefined;

	hasRawDetail: boolean = false;

	static $type: string = "CoreApi.Models.ClientEndpoints.HealthBucket, ";
	$type?: string | undefined = HealthBucket.$type;
}

